export default "__VITE_ASSET__Dw83H6v8__"